module.exports = __webpack_public_path__ + "img/solution-dianti.7cc1b726.jpg";